{
    "GenericAdminList_Footer_Add": "Adicionar",
    "GenericAdminList_Footer_View": "Visualizar",
    "GenericAdminList_Footer_Change": "alterar",
    "GenericAdminList_Footer_Delete": "remover",
    "GenericAdminList_Footer_Selected": "{} Selecionado",
    "GenericAdminList_Footer_NoRows": "Não há nada para ver aqui...",
    "NAME": "GenericAdminListLanguage"
}